<template>
    <div class="spinner"></div>
</template>

<script>
    export default {
        name: 'Spinner'
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";
    

    @keyframes spinner {
        to {
            transform: rotate(180deg);
        }
    }

    .spinner
    {
        width: 20px;
        height: 20px;
    }

    .spinner:before {
        content: "";
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        margin-left: -10px;
        border-radius: 50%;
        border: 2px solid transparent;
        border-top-color: @black;
        border-bottom-color: @black;
        animation: spinner .8s ease infinite;
    }
</style>
